let trailCount;
let trailTransition;
const trailDuration = 2000;
class TalamoraFreeShipping extends HTMLElement {
  connectedCallback() {
    const count = Number(this.dataset.count) || 0;
    if (trailCount === undefined) {
      trailCount = count;
      if (count > 0) trailTransition = {from:0,to:count,time:Date.now()};
    }
    this.update(count);
  }
  rise(p) {
    const heights = [5.28, 18.48, 42.24, 66];
    const index = Math.min(2, Math.floor(p * 3));
    return heights[index] + (heights[index + 1] - heights[index]) * (p * 3 - index);
  }
  disconnectedCallback() { clearTimeout(this.finishTimer); cancelAnimationFrame(this.frame); }
  update(count) {
    const remaining = Math.max(0, 3 - count);
    this.dataset.count = String(count);
    this.querySelector('[data-shipping-message]').textContent = remaining === 0 ? this.dataset.unlocked : remaining === 1 ? this.dataset.one : this.dataset.many.replace('[count]', String(remaining));
    this.querySelector('progress').value = Math.min(3, count);
    const moving = trailTransition && trailTransition.to === count && Date.now() - trailTransition.time < 2800;
    const from = moving ? trailTransition.from : count;
    const position = n => Math.min(1, Math.max(0, n / 3));
    clearTimeout(this.finishTimer);
    cancelAnimationFrame(this.frame);
    this.classList.remove('tm-arrived');
    this.style.setProperty('--trail-duration', '0ms');
    this.style.setProperty('--trail-progress', position(from));
    this.style.setProperty('--trail-rise', this.rise(position(from)) + 'px');
    this.classList.toggle('tm-shipping--unlocked', remaining === 0);
    if (moving && from !== count) {
      this.classList.add('tm-moving');
      this.getBoundingClientRect();
      this.frame = requestAnimationFrame(() => {
        this.style.setProperty('--trail-duration', trailDuration + 'ms');
        this.style.setProperty('--trail-progress', position(count));
        this.style.setProperty('--trail-rise', this.rise(position(count)) + 'px');
        this.finishTimer = setTimeout(() => {
          this.classList.remove('tm-moving');
          this.classList.toggle('tm-arrived', remaining === 0);
        }, trailDuration);
      });
    } else {
      this.classList.remove('tm-moving');
      this.classList.toggle('tm-arrived', remaining === 0);
    }
  }
}
if (!customElements.get('talamora-free-shipping')) customElements.define('talamora-free-shipping', TalamoraFreeShipping);
let shippingRequest = 0;
document.addEventListener('cart:update', async event => {
  if (event.detail?.data?.didError) return;
  const current = ++shippingRequest;
  let count = event.detail?.resource?.item_count;
  if (!Number.isFinite(count)) {
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
      if (!response.ok) return;
      count = (await response.json()).item_count;
    } catch { return; }
  }
  if (current !== shippingRequest || !Number.isFinite(count)) return;
  if (trailCount !== count) trailTransition = {from:trailCount ?? Math.max(0,count-1),to:count,time:Date.now()};
  trailCount = count;
  document.querySelectorAll('talamora-free-shipping').forEach(element => element.update(count));
});
